

<nav id="nav" class="master-navbar-section  secondToolbar">

  <div class="main-top-navbar" [ngClass]="{ sticky: isSticky, 'inner-header': !router.isActive('/index', true) }">
    <div class="top_header">
      <div class="wrapper">

        <div class="row-wrap" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
          fxLayout.xs="column" fxLayoutAlign="start end">

          <div fxLayout="column" fxFlex.xl="20" fxFlex.lg="20" fxFlex.md="20" fxFlex.sm="20" fxFlex.xs="100" fxFlexFill>
            <div class="top_head_img">
              <img src="../../../../../assets/images/iso.png">
            </div>
          </div>

          <div fxLayout="column" fxFlex.xl="60" fxFlex.lg="60" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="100" fxFlexFill
            fxLayoutAlign="center center">
            <div class="top_header_logo">
              <a routerLink="/index" queryParamsHandling="merge">
                  <img src="../../../../../assets/images/logo.png">
              </a>
            </div>
          </div>

          <div fxLayout="column" fxFlex.xl="20" fxFlex.lg="20" fxFlex.md="20" fxFlex.sm="20" fxFlex.xs="100" fxFlexFill
            fxLayoutAlign="end end">
            <div class="lang_chan">
            <mat-button-toggle-group [formControl]="langControl" (change)="setLanguage(langControl.value)">
              <mat-button-toggle value="en">EN</mat-button-toggle>
              <mat-button-toggle value="te">తె</mat-button-toggle>
            </mat-button-toggle-group>
          </div>
            <div class="top_head_img">
              <img src="../../../../../assets/images/member.png">
            </div>
          </div>

        </div>
        <!-- <div class="overlay_left"></div>
        <div class="overlay_right"></div> -->

      </div>
    </div>
    <!-- ------------------------ fxShow.lt-sm="false" ------------------------- -->
    <div class="header-main">
      <div class="wrapper">
        <div class="header-row" fxLayout="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="column"
          fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="8px">

          <div fxShow.lt-sm="false" fxShow.lt-md="true" fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100"
            fxFlex.sm="100" fxFlex.xs="100" fxFlexFill fxLayoutAlign="start stretch">
            <ul class="header-bottom-navbar" *ngIf="langControl.value === 'en'">
              <div class="nav_ul">
                <!-- <li> <a [routerLink]="['/index']" routerLinkActive="router-link-active" queryParamsHandling="merge"> Home </a> </li> -->
                <li> <a [routerLink]="['/About']" routerLinkActive="router-link-active" queryParamsHandling="merge">About Village</a> </li>
                <li> <a [routerLink]="['/governance_settings']" routerLinkActive="router-link-active" queryParamsHandling="merge">Village Governance</a> </li>
                <li> <a [routerLink]="['/government_offices_settings']" routerLinkActive="router-link-active" queryParamsHandling="merge">Government Offices</a> </li>
                <li> <a [routerLink]="['/public_places_settings']" routerLinkActive="router-link-active" queryParamsHandling="merge">Public Places</a> </li>
                <li> <a [routerLink]="['/village_virtual_offices']" routerLinkActive="router-link-active" queryParamsHandling="merge"> Village Virtual Office</a></li>
                <li> <a [routerLink]="['/initiatives_settings']" routerLinkActive="router-link-active" queryParamsHandling="merge">Initiatives</a> </li>
                <li> <a [routerLink]="['/transportation_facilities_settings']" routerLinkActive="router-link-active" queryParamsHandling="merge">Transportation</a> </li>
                <li> <a [routerLink]="['/village_video_items']" routerLinkActive="router-link-active" queryParamsHandling="merge">Galleries & Videos</a> </li>
                <li> <a [routerLink]="['/events_settings']" routerLinkActive="router-link-active" queryParamsHandling="merge">Events</a> </li>
                <li> <a [routerLink]="['/village_contact_settings']" routerLinkActive="router-link-active" queryParamsHandling="merge">Contact</a> </li>
              </div>
            </ul>

            <ul class="header-bottom-navbar"  *ngIf="langControl.value === 'te'">
              <div class="nav_ul">
                <!-- <li> <a [routerLink]="['/index']" routerLinkActive="router-link-active" queryParamsHandling="merge"> హోమ్</a> </li> -->
                <li> <a [routerLink]="['/About']" routerLinkActive="router-link-active" queryParamsHandling="merge">గ్రామం గురించి</a> </li>
                <li> <a [routerLink]="['/governance_settings']" routerLinkActive="router-link-active" queryParamsHandling="merge">గ్రామ పాలన</a> </li>
                <li> <a [routerLink]="['/government_offices_settings']" routerLinkActive="router-link-active" queryParamsHandling="merge">ప్రభుత్వ కార్యాలయాలు</a> </li>
                <li> <a [routerLink]="['/public_places_settings']" routerLinkActive="router-link-active" queryParamsHandling="merge">బహిరంగ ప్రదేశాలు</a> </li>
                <li> <a [routerLink]="['/village_virtual_offices']" routerLinkActive="router-link-active" queryParamsHandling="merge"> విలేజ్ వర్చువల్ ఆఫీస్</a></li>
                <li> <a [routerLink]="['/initiatives_settings']" routerLinkActive="router-link-active" queryParamsHandling="merge">చొరవ</a> </li>
                <li> <a [routerLink]="['/transportation_facilities_settings']" routerLinkActive="router-link-active" queryParamsHandling="merge">రవాణా</a> </li>
                <li> <a [routerLink]="['/village_video_items']" routerLinkActive="router-link-active" queryParamsHandling="merge">గ్యాలరీలు & వీడియోలు</a> </li>
                <li> <a [routerLink]="['/events_settings']" routerLinkActive="router-link-active" queryParamsHandling="merge">సంఘటనలు</a> </li>
                <li> <a [routerLink]="['/village_contact_settings']" routerLinkActive="router-link-active" queryParamsHandling="merge">సంప్రదించండి</a> </li>
              </div>
            </ul>


          </div>
        </div>
      </div>
    </div>
  </div>
</nav>
<!-- MOBILE-MENU -->
<div class="top-navbar mobile_menu mobile-top-menu-show" fxFlex.gt-md="false">
  <div class="" fxLayout="column" fxFlex="100" fxFlexFill>
    <div class="mobile-navbar-sec" [ngClass]="{ sticky: isSticky, 'inner-header': !router.isActive('/index', true) }">
      <div class="mobile-logo-box" [routerLink]="['/index']" routerLinkActive="router-link-active">
        <!-- <img *ngIf="router.isActive('/index', true)" [routerLink]="['/index']" routerLinkActive="router-link-active"
          src="../../../../../assets/images/logo.svg" alt="" />
        <img *ngIf="!router.isActive('/index', false)" [routerLink]="['/index']" routerLinkActive="router-link-active"
          src="../../../../../assets/images/footer-logo.svg" alt="" /> -->
        <img [routerLink]="['/']" routerLinkActive="router-link-active" src="../../../../../assets/images/logo.png"
          alt="" />
      </div>
      <div class="mobile-accordion">
        <mat-accordion>
          <mat-expansion-panel [(expanded)]="xpandStatus">
            <mat-expansion-panel-header class="toggler" [collapsedHeight]="customNavCollapsedHeight"
              [expandedHeight]="customNavExpandedHeight">
              <mat-panel-title>
                <div class="mobile-toolbar-toggler">
                  <span class=""></span>
                  <span class=""></span>
                  <span class=""></span>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="top-right-nav">
              <li> <a (click)='xpandStatus=xpandStatus?false:true' [routerLink]="['/About', 'profile']" routerLinkActive="router-link-active" queryParamsHandling="merge">About Village</a> </li>
              <li> <a (click)='xpandStatus=xpandStatus?false:true' [routerLink]="['/governance_settings', 'grampanchayat']" routerLinkActive="router-link-active" queryParamsHandling="merge">Village Governance</a> </li>
              <li> <a (click)='xpandStatus=xpandStatus?false:true' [routerLink]="['/government_offices_settings', 'grampanchayat']" routerLinkActive="router-link-active" queryParamsHandling="merge">Government Offices</a> </li>
              <li> <a (click)='xpandStatus=xpandStatus?false:true' [routerLink]="['/public_places_settings', 'mosques']" routerLinkActive="router-link-active" queryParamsHandling="merge">Public Places</a> </li>
              <li> <a (click)='xpandStatus=xpandStatus?false:true' [routerLink]="['/village_virtual_offices']" routerLinkActive="router-link-active" queryParamsHandling="merge"> Village Virtual Office</a></li>
              <li> <a (click)='xpandStatus=xpandStatus?false:true' [routerLink]="['/initiatives_settings', 'various_development_works_status']" routerLinkActive="router-link-active" queryParamsHandling="merge">Initiatives</a> </li>
              <li> <a (click)='xpandStatus=xpandStatus?false:true' [routerLink]="['/transportation_facilities_settings', 'roads']" routerLinkActive="router-link-active" queryParamsHandling="merge">Transportation</a> </li>
              <li> <a (click)='xpandStatus=xpandStatus?false:true' [routerLink]="['/village_video_items']" routerLinkActive="router-link-active" queryParamsHandling="merge">Galleries & Videos</a> </li>
              <li> <a (click)='xpandStatus=xpandStatus?false:true' [routerLink]="['/events_settings', 'religious_celebrations']" routerLinkActive="router-link-active" queryParamsHandling="merge">Events</a> </li>
              <li> <a (click)='xpandStatus=xpandStatus?false:true' [routerLink]="['/village_contact_settings', 'how_to_reach']" routerLinkActive="router-link-active" queryParamsHandling="merge">Contact</a> </li>
            </ul>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </div>
  <div fxLayout="column" fxFlex.xl="20" fxFlex.lg="20" fxFlex.md="20" fxFlex.sm="20" fxFlex.xs="100" fxFlexFill
  fxLayoutAlign="end end">
  <div class="lang_chan">
  <mat-button-toggle-group [formControl]="langControl" (change)="setLanguage(langControl.value)">
    <mat-button-toggle value="en">EN</mat-button-toggle>
    <mat-button-toggle value="te">తె</mat-button-toggle>
  </mat-button-toggle-group>
</div>
</div>
</div>
<span (click)="scrollTop()" class="scroll-top" [ngClass]="{ 'scroll-top-in': isScrollTop }">
  <i class="material-icons"> keyboard_arrow_up</i>
</span>
<!-- <div class="float_sm">
  <a href="http://www.facebook.com/PeacefullNarmetta" target="_blank">
    <div class="fl-fl float-fb fb-bg">
      <div class="social-icon">
        <img src="../../../../../assets/images/fb.png" alt="">
      </div>
      <span> Facebook</span>
    </div>
  </a>
  <a [href]="" target="_blank">
    <div class="fl-fl float-in in-bg">
      <div class="social-icon">
        <img src="../../../../../assets/images/insta.png" alt="">
      </div>
      <span>Instagram</span>
    </div>
  </a>
  <a [href]="" target="_blank">
    <div class="fl-fl float-tw tw-bg">
      <div class="social-icon">
        <img src="../../../../../assets/images/twitter.png" alt="">
      </div>
      <span>Twitter</span>
    </div>
  </a> -->
  <!-- <a [href]="" target="_blank">
    <div class="yt-bg fl-fl float-yt">
      <div class="social-icon">
        <img src="../../../../../assets/images/youtube.svg" alt="">
      </div>
      <span>Youtube</span>
    </div>
  </a>
  <a target="_blank">
    <div class="ln-bg fl-fl float-ln">
      <div class="social-icon">
        <img src="../../../../../assets/images/linkedin.svg" alt="">
      </div>
      <span>LinkedIn</span>
    </div>
  </a> -->
<!-- </div> -->
